import { useMemo } from 'react';

import { GridColDef } from '@mui/x-data-grid';

import { AssetResourceCategoryMenuItem, FilterFieldProps } from '../types';
import { resourceCategoriesToFilterFields } from '../utils/tableState';

export const useTableValidationContext = (
  columns: GridColDef[],
  resourceCategories: AssetResourceCategoryMenuItem[],
  schemaFilterFields: FilterFieldProps[],
) => {
  const filterFields: FilterFieldProps[] = useMemo(() => {
    return [...schemaFilterFields, ...resourceCategoriesToFilterFields(resourceCategories)];
  }, [resourceCategories, schemaFilterFields]);

  return {
    columns,
    filterFields,
  };
};
